import { atom } from "jotai";

export const InventoryHistoryPageAtom = atom(1);
export const InventoryHistoryPageSizeAtom = atom(10);
